(ns leg.page
  "The shell the two full-window pages share: a title, a column no wider than
  a column of text, and the bar every screen in this window has at its foot.

  A page is neither a fourth pane of the reader nor a dialog. It has an
  address (`leg.route`), it takes the whole window, and it is left with the
  back button - the browser's own, or the one in the bar, which does the same
  thing. Settings and the readers are both that, so the frame around them is
  one piece of code and not two that drift apart.

  The title is the `h1` of the page, which is where the one heading goes
  when the article that usually carries it is not on the screen."
  (:require-macros [kc.core :refer [def-ui $]])
  (:require [leg.mui :as mui :refer [sx]]
            [leg.nav :as nav]
            [leg.state :as state]
            [leg.theme :as theme]))

(def-ui Page [title loading? ***]
  ($ mui/Box {:sx (sx {:height "100vh" :display "flex" :flexDirection "column"
                       :overflow "hidden"
                       :backgroundColor "background.default"})}
     ($ mui/Box {:component "main"
                 :sx (sx {:flex "1" :minHeight 0 :overflowY "auto"})}
        ($ mui/Box {:sx (sx {:maxWidth "38rem" :margin "0 auto"
                             :padding "1rem .9rem 3rem"})}
           ;; The title with nothing beside it: the way back is at the foot
           ;; of the screen, where every other screen in this window keeps
           ;; it.
           ($ mui/Box {:sx (sx {:borderBottom "3px double" :borderColor "divider"
                                :paddingBottom ".45rem"})}
              ($ :h1 {:style {:margin 0 :fontFamily theme/font-head
                              :fontWeight 900 :fontSize "1.35rem" :lineHeight 1}}
                 title))
           (when loading? ($ mui/LinearProgress))
           ***))
     ($ nav/Bar {:label title
                 :left ($ nav/Home)
                 :right ($ mui/Button {:onClick (fn [_] (state/close-page!))}
                           "Back")})))

(def-ui Section
  "One thing the page is about, under the small upright label this window
  uses for everything that is not prose."
  [title ***]
  ($ mui/Box
     ($ mui/Typography {:sx (sx {:fontSize ".8rem" :color "text.secondary"
                                 :textTransform "uppercase" :letterSpacing ".08em"})}
        title)
     ($ mui/Box {:sx (sx {:marginTop ".25rem"})} ***)))
